import React from 'react';
import Modal from 'components/common/modal-component';
import { ModalButton } from 'models/utils/common/modal-button-model';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const RESET_ANNOTATION_MODAL_BLOCK = 'reset-annotation';
const ResetAnnotationPosition = ({ onClose, onConfirm }) => {
  return (
    <Modal
      id={RESET_ANNOTATION_MODAL_BLOCK}
      title={'reset-annotations-modal.title'}
      onClose={onClose}
      primaryModalButton={
        new ModalButton({
          text: 'common.yes',
          onClick: onConfirm,
        })
      }
      secondaryModalButton={
        new ModalButton({
          text: 'common.no',
          onClick: onClose,
        })
      }
    >
      <div className={`${RESET_ANNOTATION_MODAL_BLOCK}__label`}>
        <FormattedMessage id="reset-annotations-modal.body" />
      </div>
    </Modal>
  );
};

ResetAnnotationPosition.propTypes = {
  // Function to be called when user clicks on cross or No button of modal
  onClose: PropTypes.func.isRequired,
  // Function to be called when user clicks on Yes button of modal
  onConfirm: PropTypes.func.isRequired,
};

export default ResetAnnotationPosition;
